(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('slideshow-thumbnails', class extends baseComponent.default {
      elements = {
          items: '*[data-item]',
          scroller: '[data-thumbnails-scroller]'
      }
      // The scroller hides its scrollbar, so nothing said more thumbs were out of view.
      // Mark the ends that have more; slideshow-thumbnails.css fades the rail out there.
      render() {
          this.scroller = this.$scroller || (this.$items[0] && this.$items[0].parentNode);
          if (!this.scroller) return;
          const update = () => this._updateOverflow();
          this.scroller.addEventListener('scroll', update, { passive: true });
          if (window.ResizeObserver) new ResizeObserver(update).observe(this.scroller);
          update();
      }
      onSliderLoad(slider) {
          this.slider = slider;
          this._setActive(this.slider.swiper.activeIndex);
          this.$items.map((item, i) => {
              item.addEventListener('click', () => {
                  this.slider.slideTo(i);
              });
          })
          this.slider.swiper.on('slideChange', () => {
              this._setActive(this.slider.swiper.activeIndex);
          })
          this._updateOverflow();
      }
      _setActive(index) {
          if(this.active) {
              this.active.classList.remove('!active');
          }
          // Guard: this runs inside a slideChange handler, and throwing there aborts the
          // rest of Swiper's listener chain for that event.
          if(!this.$items[index]) return;
          this.active = this.$items[index];
          this.active.classList.add('!active');
          this._scrollToActive();
      }

      // The rail is vertical beside the image and horizontal below it on mobile, so
      // follow whichever axis actually overflows rather than a build-time attribute.
      // The scroller is the items' offsetParent in both orientations.
      _scrollToActive() {
          const scroller = this.active.parentNode;
          if(scroller.scrollWidth > scroller.clientWidth) {
              scroller.scrollLeft = this.active.offsetLeft
                  - (scroller.clientWidth - this.active.offsetWidth) / 2;
          }
          if(scroller.scrollHeight > scroller.clientHeight) {
              scroller.scrollTop = this.active.offsetTop
                  - (scroller.clientHeight - this.active.offsetHeight) / 2;
          }
      }

      _updateOverflow() {
          const scroller = this.scroller;
          if(!scroller) return;
          const horizontal = scroller.scrollWidth - scroller.clientWidth > 1;
          const position = horizontal ? scroller.scrollLeft : scroller.scrollTop;
          const max = horizontal
              ? scroller.scrollWidth - scroller.clientWidth
              : scroller.scrollHeight - scroller.clientHeight;
          // 1px of slack: fractional sizes leave the end a sub-pixel short of max.
          this.toggleAttribute('data-more-before', max > 1 && position > 1);
          this.toggleAttribute('data-more-after', max > 1 && position < max - 1);
      }
  });
})();
